import { useCabinetStore } from '../storePinia/stores/cabinet';

const getPersonalData = async (to, from, next) => {
  if (from.path !== '/') {
    const cabinetStore = useCabinetStore();
    await cabinetStore.loadPageData(to.path);
  }
  next();
};

export default [
  {
    path: '/:language?/personal',
    // component: require('../components/Cabinet/Personal/Personal').default,
    component: () =>
      import(/* webpackChunkName: 'personal-personal' */ '../components/Cabinet/Personal/Personal'),
    beforeEnter: getPersonalData,
  },
  {
    path: '/:language?/personal/history',
    // component: require('../components/Cabinet/History/History.vue').default,
    component: () =>
      import(
        /* webpackChunkName: 'personal-history' */ '../components/Cabinet/History/History.vue'
      ),
    beforeEnter: getPersonalData,
  },
  {
    path: '/:language?/personal/box',
    // component: require('../components/Cabinet/Box/Box.vue').default,
    component: () =>
      import(/* webpackChunkName: 'personal-box' */ '../components/Cabinet/Box/Box.vue'),
    beforeEnter: getPersonalData,
  },
  {
    path: '/:language?/personal/service',
    // component: require('../components/Cabinet/Service/Service.vue').default,
    component: () =>
      import(
        /* webpackChunkName: 'personal-service' */ '../components/Cabinet/Service/Service.vue'
      ),
    beforeEnter: getPersonalData,
  },
  {
    path: '/:language?/personal/wishlist',
    // component: require('../components/Cabinet/Favourite/Favourite.vue').default,
    component: () =>
      import(
        /* webpackChunkName: 'personal-Favourite' */ '../components/Cabinet/Favourite/Favourite.vue'
      ),
    beforeEnter: getPersonalData,
  },
  {
    path: '/:language?/personal/viewed',
    // component: require('../components/Cabinet/Viewed/Viewed.vue').default,
    component: () =>
      import(/* webpackChunkName: 'personal-viewed' */ '../components/Cabinet/Viewed/Viewed.vue'),
    beforeEnter: getPersonalData,
  },
  {
    path: '/:language?/personal/warranties',
    component: () =>
      import(
        /* webpackChunkName: 'personal-guarantees' */ '../components/Cabinet/Guarantees/Guarantees.vue'
      ),
    beforeEnter: getPersonalData,
  },
  {
    path: '/:language?/personal/discounts',
    // component: require('../components/Cabinet/Discounts/Discounts.vue').default,
    component: () =>
      import(
        /* webpackChunkName: 'personal-discounts' */ '../components/Cabinet/Discounts/Discounts.vue'
      ),
    beforeEnter: getPersonalData,
  },
  {
    path: '/:language?/personal/purchases',
    // component: require('../components/Cabinet/Purchases/Purchases.vue').default,
    component: () =>
      import(
        /* webpackChunkName: 'personal-purchases' */ '../components/Cabinet/Purchases/Purchases.vue'
      ),
    beforeEnter: getPersonalData,
  },
  {
    path: '/:language?/personal/addresses',
    component: () =>
      import(
        /* webpackChunkName: 'personal-purchases' */ '../components/Cabinet/Addresses/Addresses.vue'
      ),
    beforeEnter: getPersonalData,
  },
  {
    path: '/:language?/personal/filters',
    component: () =>
      import(
        /* webpackChunkName: 'personal-purchases' */ '../components/Cabinet/Filters/Filters.vue'
      ),
    beforeEnter: getPersonalData,
  },
];
